<template>
    <div class="d-flex flex-column align-items-center justify-content-center ulohy-row">
        <div class="mb-30">
            <skoly-ulohy-row-item v-if="kvizovaUloha" :uloha="kvizovaUloha" typ="kvizova" />
            <skoly-ulohy-row-item v-if="tvorivaUloha" :uloha="tvorivaUloha" typ="tvoriva" :profil="profil" />
        </div>
        <div class="text-center">
            <p class="text-21 text-bold text-dark mb-10">{{ label }}</p>
            <span class="tag tag--mesiac" :class="{ 'tag--active': isActive }">{{ mesiac }}</span>
        </div>
    </div>
</template>

<script>
import SkolyUlohyRowItem from "@/components/skoly/SkolyUlohyRowItem.vue";

export default {
    components: {SkolyUlohyRowItem},
    props: [ 'mesiac', 'label', 'kvizovaUloha', 'tvorivaUloha', 'profil' ],
    data() {
        return {}
    },
    computed: {
        isActive() {
            let monthIndex = new Date().getMonth();
            switch (monthIndex) {
                case 0:return this.mesiac === 'január'
                case 1:return this.mesiac === 'február'
                case 2:return this.mesiac === 'marec'
                case 3:return this.mesiac === 'apríl'
                case 4:return this.mesiac === 'máj'
                case 5:return this.mesiac === 'jún'
                case 6:return this.mesiac === 'september'
                case 7:return this.mesiac === 'september'
                case 8:return this.mesiac === 'september'
                case 9:return this.mesiac === 'október'
                case 10:return this.mesiac === 'november'
                case 11:return this.mesiac === 'december'
            }
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
